import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const RelatedEvents2022Zh = () => {
  use2022Page({ cate: 'related_events', lang: 'zh', title: '2022智慧生活夥伴大獎 - 相關活動' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/Wave_bg.png" alt="" /></div></section>
      <section id="RelatedEvents"><div className="RelatedEvents_info"><div className="RelatedEvents_Title">相關活動</div><div className="RelatedEvents_TitleLine"><div className="RelatedEvents_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="RelatedEvents"><div className="RelatedEvents_Table"><div className="RelatedEvents_box"><div className="RelatedEvents_Details">2021智慧生活夥伴大獎</div><a href="/2021"><img src="/2022/images/RelatedEvent2021.jpg" alt="" /></a></div><div className="RelatedEvents_box"><div className="RelatedEvents_Details">2018香港智慧城市大獎</div><a href="/2018"><img src="/2022/images/RelatedEvent2018.jpg" alt="" /></a></div></div></div></div></section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default RelatedEvents2022Zh;

